import { useContext } from 'react';
import { ScreenContext, ScreenContextState } from './_screen.context';

export function useScreenContext(): ScreenContextState {
	const screenContext = useContext(ScreenContext);
	if (screenContext === undefined) {
		throw new Error('useScreenContext must be used within a ScreenProvider');
	}

	return screenContext;
}
